<template>
  <button
    :class="['v-button', element.type == 'round' && 'roundBtn', fontFamilyCls, usesImageBg && 'is-image-bg']"
    :style="previewStyle"
    :disabled="previewLoading"
    @click.stop="mouseEventHandler('down')"
  >
    <i v-if="element.style.btnIcon" :class="['wirdfont']">{{ unicodeToChar(element.style.btnIcon) }}</i>{{ isPreview && allBtnPressMap[element.id] ? (element.style.btnPressName || propValue) : propValue }}
    <span v-if="previewLoading" class="btn-loading-mask"><i class="el-icon-loading" /></span>
  </button>
</template>

<script>
// import { mapState } from "vuex";
import { isEmpty, unicodeToChar } from '@/utils/utils';
import { fontFamilyMap } from '@/utils/attrNameData';
import eventBus from '@/utils/eventBus';
import { isButtonIconBackground } from '@/utils/style';
export default {
  props: {
    propValue: {
      type: String,
      default: "",
    },
    element: {
      type: Object,
      default: () => {},
    },
    isPreview: Boolean,
    currentComps: {
      type: String,
      require: false
    },
    childPageComps: {
      type: Array,
      require: false
    },
    allBtnPressMap: {
      type: Object,
      require: false
    }
  },
  data() {
    return {
      isPreviewPress: false,
      previewLoading: false
    };
  },
  computed: {
    fontFamilyCls() {
      let cls = '';
      if (this.element.style && this.element.style.fontFamily) {
        cls = 'diy-' + fontFamilyMap[this.element.style.fontFamily];
      }
      return cls;
    },
    usesImageBg() {
      const st = this.element.style || {};
      const pressed = !!(this.isPreview && this.allBtnPressMap && this.allBtnPressMap[this.element.id]);
      return isButtonIconBackground(st, pressed);
    },
    previewStyle() {
      const st = this.element.style || {};
      const pressed = !!(this.isPreview && this.allBtnPressMap && this.allBtnPressMap[this.element.id]);
      const style = {};
      if (!this.isPreview) {
        // 编辑态点击穿透到 Shape，才能单独选中按钮（不被原生 button 吃掉事件）
        style.pointerEvents = "none";
      }
      if (isButtonIconBackground(st, pressed)) {
        style.backgroundColor = "transparent";
        if (this.isPreview) {
          style.backgroundImage = pressed ? st.pressBackgroundImage : st.backgroundImage;
        }
        return style;
      }
      if (this.isPreview) {
        style.backgroundImage = "none";
        style.backgroundColor = pressed ? st.pressBackgroundColor : st.backgroundColor;
      }
      return style;
    },
  },
  // computed: mapState(["componentData", "curComponent"]),
  methods: {
    unicodeToChar,
    /** 预览态下根据 id 解析按钮展示名（含生态子组件） */
    previewResolveButtonLabel(compId) {
      const list =
        (this.childPageComps && this.childPageComps.length
          ? this.childPageComps
          : null) ||
        (this.$store && this.$store.state && this.$store.state.componentData) ||
        [];
      const found = this.previewFindCompById(list, compId);
      if (!found) {
        return String(compId);
      }
      return (
        found.propValue ||
        (found.style && found.style.alias) ||
        found.label ||
        String(found.id)
      );
    },
    previewFindCompById(list, compId) {
      if (!list || !compId) {
        return null;
      }
      for (let i = 0; i < list.length; i++) {
        const c = list[i];
        if (String(c.id) === String(compId)) {
          return c;
        }
        if (c.propValue && Array.isArray(c.propValue)) {
          const sub = this.previewFindCompById(c.propValue, compId);
          if (sub) {
            return sub;
          }
        }
      }
      return null;
    },
    previewLogJump(targetPageKey) {
      const btn = this.previewResolveButtonLabel(this.element.id);
      let pageDesc = String(targetPageKey);
      try {
        const raw = this.$store && this.$store.state.canvasAllData;
        if (raw) {
          const data = typeof raw === "string" ? JSON.parse(raw) : raw;
          const row = data[targetPageKey];
          const name = row && row[0] && row[0].style && row[0].style.pageName;
          if (name) {
            pageDesc = `「${name}」（页面键：${targetPageKey}）`;
          }
        }
      } catch (e) {
        /* ignore */
      }
      console.log(
        `[预览·页面跳转] 当前点击按钮「${btn}」（组件 id：${this.element.id}）。触发指令：页面跳转，将切换到页面 ${pageDesc}。`
      );
    },
    previewLogPressList(title, items, curentIsPress) {
      const btn = this.previewResolveButtonLabel(this.element.id);
      const lines = (items || []).map((item) => {
        const name = this.previewResolveButtonLabel(item.id);
        const toPress = item.status !== "0";
        return `将按钮「${name}」（id：${item.id}）设为「${
          toPress ? "按压" : "释放"
        }」状态`;
      });
      console.log(
        `[预览·${title}] 当前点击按钮「${btn}」（id：${
          this.element.id
        }）。触发时本按钮${
          curentIsPress ? "已处于按压" : "处于未按压"
        }态。联动结果：${lines.join("；")}。`
      );
    },
    previewLogMutually(mutuallyEvent, curentIsPress) {
      const btn = this.previewResolveButtonLabel(this.element.id);
      const lines = mutuallyEvent.map((oid) => {
        const name = this.previewResolveButtonLabel(oid);
        return `按钮「${name}」（id：${oid}）将被设为「${
          curentIsPress ? "按压" : "释放"
        }」态（与当前按钮互斥联动）`;
      });
      console.log(
        `[预览·互斥联动] 当前点击按钮「${btn}」（id：${this.element.id}）。${
          curentIsPress
            ? "当前为按压态再点击，即将切换为释放；"
            : "当前为未按压态，即将切换为按压；"
        }${lines.join("；")}。`
      );
    },
    previewLogNetworkHints(nextPress) {
      const btn = this.previewResolveButtonLabel(this.element.id);
      const nc = this.element.networkConfig || {};
      const d1 = nc.directives || [];
      const d2 = nc.directives2 || [];
      const names = (arr) =>
        arr
          .map((d) => d.instruction_name || d.name || "未命名指令")
          .join("、");
      if (nextPress && d1.length) {
        console.log(
          `[预览·网络指令说明] 按钮「${btn}」已绑定按压指令 ${d1.length} 条：${names(
            d1
          )}。说明：预览模式不会向设备真实下发，仅模拟界面联动与状态。`
        );
        this.$message.info(`模拟下发按压指令：${names(d1)}（预览不真实发送）`);
      }
      if (!nextPress && d2.length) {
        console.log(
          `[预览·网络指令说明] 按钮「${btn}」已绑定二次按压指令 ${d2.length} 条：${names(
            d2
          )}。说明：预览模式不会向设备真实下发。`
        );
        this.$message.info(`模拟下发二次按压指令：${names(d2)}（预览不真实发送）`);
      }
    },
    previewLogClickBind() {
      const ev = this.element.events || {};
      const ce = ev.clickEvent;
      if (!ce || !ce.comp || !ce.event) {
        return;
      }
      const target = this.previewResolveButtonLabel(ce.comp);
      console.log(
        `[预览·点击绑定] 按钮「${this.previewResolveButtonLabel(
          this.element.id
        )}」配置了对其它组件的联动：目标组件「${target}」（id：${
          ce.comp
        }），事件类型：${ce.event}。`
      );
    },
    previewPlayPressRing() {
      if (!this.element.style || !this.element.style.pressRing) {
        return;
      }
      try {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) {
          return;
        }
        const ctx = new Ctx();
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.frequency.value = 880;
        gain.gain.value = 0.08;
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start();
        osc.stop(ctx.currentTime + 0.08);
        setTimeout(() => {
          if (ctx.close) {
            ctx.close();
          }
        }, 200);
      } catch (e) {
        /* ignore */
      }
    },
    previewDispatchClickBind() {
      if (!this.element.style || !this.element.style.oneClick) {
        return;
      }
      const ce = (this.element.events || {}).clickEvent;
      if (!ce || !ce.comp || !ce.event) {
        return;
      }
      eventBus.$emit("previewMediaAction", {
        targetId: ce.comp,
        event: ce.event,
      });
    },
    previewEventHandler() {
      const events = this.element.events || {};
      if (
        this.element.style.oneClick &&
        events.jumpEvent &&
        events.jumpEvent.length !== 0
      ) {
        const targetKey = events.jumpEvent[0];
        this.previewLogJump(targetKey);
        this.$emit("changePage", targetKey);
      }
      let id = this.element.id;
      let curentIsPress = !!this.allBtnPressMap[id];
      let pressEvent = events.pressEvent || [];
      if (!curentIsPress && pressEvent.length !== 0) {
        this.previewLogPressList("按压联动", pressEvent, curentIsPress);
        let arr = [];
        pressEvent.map((item) => {
          arr.push({
            id: item.id,
            isPress: item.status !== "0",
          });
        });
        this.$emit("changeBtnPress", arr);
      }
      let pressAgainEvent = events.pressAgainEvent || [];
      if (curentIsPress && pressAgainEvent.length !== 0) {
        this.previewLogPressList("再次按压联动", pressAgainEvent, curentIsPress);
        let arr = [];
        pressAgainEvent.map((item) => {
          arr.push({
            id: item.id,
            isPress: item.status !== "0",
          });
        });
        this.$emit("changeBtnPress", arr);
      }
      let mutuallyEvent = events.mutuallyEvent || [];
      const nextPress = !curentIsPress;
      if (mutuallyEvent.length !== 0 && nextPress) {
        this.previewLogMutually(mutuallyEvent, curentIsPress);
        let arr = [];
        mutuallyEvent.map((mid) => {
          arr.push({
            id: mid,
            isPress: false,
          });
        });
        this.$emit("changeBtnPress", arr);
      } else if (mutuallyEvent.length !== 0) {
        this.previewLogMutually(mutuallyEvent, curentIsPress);
      }
    },
    runPreviewClick() {
      this.previewPlayPressRing();
      this.previewLogClickBind();
      this.previewDispatchClickBind();
      const nextPress = !this.allBtnPressMap[this.element.id];
      this.previewLogNetworkHints(nextPress);
      this.previewEventHandler();
      console.log(
        `[预览·本按钮状态] 按钮「${this.previewResolveButtonLabel(
          this.element.id
        )}」（id：${this.element.id}）本次点击后切换为「${
          nextPress ? "按压" : "释放"
        }」显示态。`
      );
      this.$emit("changeBtnPress", [
        { id: this.element.id, isPress: nextPress },
      ]);
      const style = this.element.style || {};
      if (style.btnLoading) {
        this.previewLoading = true;
        const ms = (Number(style.btnLoadingTime) || 0) * 1000;
        setTimeout(() => {
          this.previewLoading = false;
        }, ms);
      }
    },
    mouseEventHandler() {
      if (!this.isPreview) return;
      if (this.previewLoading) return;
      const style = this.element.style || {};
      if (style.modalConfirm) {
        this.$confirm(this.$tt("确认执行该操作？"), this.$tt("操作确认"), {
          confirmButtonText: this.$tt("确定"),
          cancelButtonText: this.$tt("取消"),
          type: "warning",
        })
          .then(() => {
            this.runPreviewClick();
          })
          .catch(() => {});
        return;
      }
      this.runPreviewClick();
    },
  },
};
</script>

<style lang="scss">
.v-button {
  .wirdfont {
    font-size: inherit;
  }
}
</style>
<style lang="scss" scoped>
.v-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background-color: transparent;
  background-image: none;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  width: 100%;
  height: 100%;
  font-size: 14px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  white-space: pre-line;
  &:active {
    color: #3a8ee6;
    border-color: #3a8ee6;
    outline: 0;
  }

  &:hover:not(.is-image-bg) {
    background-color: #ecf5ff;
    color: #3a8ee6;
  }
  &.is-image-bg {
    background-color: transparent !important;
    border-color: transparent;
    &:hover {
      background-color: transparent;
    }
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.85;
  }
}
.btn-loading-mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #409eff;
}
.roundBtn {
  border-radius: 50% !important;
}
</style>
